const CATEGORIES_ACTION_TYPES = {
  SET_CATEGORIES_MAP: 'categories/SET_CATEGORIES_MAP',
};

export default CATEGORIES_ACTION_TYPES;
